module.exports = __webpack_public_path__ + "static/media/staff.e71e62ee.svg";